export default "__VITE_ASSET__CjgGm$FM__"